import { compose } from "redux";

import withSecondaryBarSet from "app/pages/sales-intelligence/hoc/withSecondaryBarSet";
import SfEnrichmentJobEditor from "app/pages/sales-intelligence/modules/crm-enrichment/impl/salesforce/containers/SfEnrichmentJobEditor";
import { withConnectionCheck } from "app/pages/sales-intelligence/pages/manage-integration/hocs/withConnectionCheck";
import withCrmEnrichmentProvider from "app/pages/sales-intelligence/pages/manage-integration/hocs/withCrmEnrichmentProvider";
import { withMappingsAndColumnsFetch } from "app/pages/sales-intelligence/pages/manage-integration/hocs/withMappingsAndColumnsFetch";

const SfEnrichmentJobEditContainer = compose(
    withCrmEnrichmentProvider,
    withConnectionCheck,
    withSecondaryBarSet("SalesIntelligenceManagement"),
    withMappingsAndColumnsFetch({ refetchIfExists: true }),
)(SfEnrichmentJobEditor);

export default SfEnrichmentJobEditContainer;
